import { render, staticRenderFns } from "./DeviceModelForm.vue?vue&type=template&id=ebf28f16&"
import script from "./DeviceModelForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceModelForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports